import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'

import home from './components/home'
Vue.use(Router)

const router = new Router({  
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    }
  ],
  mode: 'history'
})

export default router

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router: router,
}).$mount('#app')
